<script module lang="ts">
  export interface Props {
    /** Shown instead of every page while the `password_change` todo is open. */
    forced?: boolean;
  }
</script>

<script lang="ts">
  import { CommonTexts } from '../../../../services/CommonTexts';
  import { UsersTexts } from '../../UsersTexts';
  import Content from '../../../../components/content/Content.svelte';
  import Form from '../../../../components/forms/Form.svelte';
  import FormInput from '../../../../components/forms/FormInput.svelte';
  import FormButton from '../../../../components/forms/FormButton.svelte';
  import FormButtonLine from '../../../../components/forms/FormButtonLine.svelte';
  import ErrorMessages from '../../../../components/boxes/ErrorMessages.svelte';
  import SuccessBox from '../../../../components/boxes/SuccessBox.svelte';
  import { ApiService } from '../../../../api/services/ApiService';
  import { UserService } from '../../../../services/UserService.svelte.js';
  import Box from '../../../../components/boxes/Box.svelte';

  const { forced = false }: Props = $props();

  // -
  let OldPassword = $state('');
  let NewPassword = $state('');
  let NewPasswordRepeat = $state('');
  let IsLoading = $state(false);
  let Errors: string[] = $state([]);
  let IsChanged = $state(false);

  async function submitChange(event: SubmitEvent): Promise<void> {
    event.preventDefault();
    if (IsLoading) {
      return;
    }

    if (NewPassword !== NewPasswordRepeat) {
      Errors = [UsersTexts.PasswordsDiffer];
      return;
    }

    // -
    IsLoading = true;
    Errors = [];
    IsChanged = false;
    const Result = await ApiService.users.changePassword(OldPassword, NewPassword);
    IsLoading = false;
    if (!Result.isOk) {
      Errors = ApiService.listErrorTexts(Result);
      return;
    }

    // - a forced change disappears with the todo
    OldPassword = '';
    NewPassword = '';
    NewPasswordRepeat = '';
    IsChanged = true;
    await UserService.refresh();
  }
</script>

<Box layerAbs={true} lightDarker={true}>
  {#snippet headline()}{UsersTexts.PasswordChange}{/snippet}
  <Content>
    {#if forced}
      <p>{UsersTexts.PasswordForcedIntro}</p>
    {:else}
      <p>{UsersTexts.PasswordChangeIntro}</p>
    {/if}
  </Content>

  <ErrorMessages errors={Errors} />

  {#if IsChanged}
    <SuccessBox>
      {#snippet headline()}{CommonTexts.Done}{/snippet}
      <p>{UsersTexts.PasswordChangedMail}</p>
    </SuccessBox>
  {/if}

  <Form onsubmit={submitChange}>
    <FormInput type="password" label={UsersTexts.PasswordOld} name="old_password" required bind:value={OldPassword} />
    <FormInput type="password" label={UsersTexts.PasswordNew} name="new_password" autocomplete="new-password" required bind:value={NewPassword} />
    <FormInput type="password" label={UsersTexts.PasswordNewRepeat} name="new_password_repeat" autocomplete="new-password" required bind:value={NewPasswordRepeat} />
    <FormButtonLine>
      <FormButton type="submit" disabled={IsLoading}>{UsersTexts.PasswordChange}</FormButton>
    </FormButtonLine>
  </Form>
</Box>
